export default __webpack_public_path__ + "static/media/AboutmeVertical.fa278138.PNG";